import AnalyticsService from '../services/analytics/analyticsService';
import { db } from '../db/db';
import { EventName } from '../services/analytics/providers/analyticsProvider';
import TrimboxServerClient from '../services/serverClient';

export async function checkForPaidCheckoutSession(): Promise<boolean> {
  try {
    const checkoutSessions = await db.checkoutSessions.toArray();

    if (!checkoutSessions || checkoutSessions.length === 0) {
      return false;
    }

    const checkoutSession = checkoutSessions[0];

    AnalyticsService.track(EventName.CHECKOUT_CAPTURE);

    const client: TrimboxServerClient = new TrimboxServerClient();
    const checkoutSessionData = await client.getCheckoutSession(checkoutSession.session_id);

    if (checkoutSessionData.payment_status !== 'paid') {
      return false;
    }

    AnalyticsService.logCheckoutConversion(checkoutSessionData);

    await db.checkoutSessions.delete(checkoutSession.session_id);

    return true;
  } catch (error) {
    AnalyticsService.trackError(EventName.LOG_CHECKOUT_SESSION_ERROR, error);
    return false;
  }
}
